/**
 * Função para remover campos de um objeto
 * @param {Object} data - O objeto de onde os campos serão removidos.
 * @param {Array} fieldsToRemove - Um array de strings representando os campos a serem removidos.
 * @return {Object} - O objeto resultante após a remoção dos campos especificados.
 */

export const removeFields = (data, fieldsToRemove) => {
  return Object.fromEntries(
    Object.entries(data).filter(([key]) => !fieldsToRemove.includes(key))
  );
};
